import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import BackButton from "@/components/BackButton";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError(null);
        try {
            await api.post("/auth/reset-password", { token, password });
            toast.success("Password aggiornata.");
            navigate("/login");
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || "Errore. Riprova.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="co-container py-14 sm:py-20 max-w-md" data-testid="reset-page">
            <div className="mb-4"><BackButton testid="reset-back-btn" /></div>
            <span className="co-caption">Reset Password</span>
            <h1 className="font-serif text-4xl mt-2 mb-8">Reimposta la password</h1>

            {!token ? (
                <p className="text-sm text-[hsl(var(--destructive))]">Token mancante nel link.</p>
            ) : (
                <form onSubmit={submit} className="space-y-5">
                    <div>
                        <Label htmlFor="password" className="co-caption mb-2 block">Nuova password (min. 8)</Label>
                        <Input
                            id="password" type="password" required minLength={8}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            data-testid="reset-password-input"
                            className="bg-white h-11"
                        />
                    </div>
                    {error && <p className="text-sm text-[hsl(var(--destructive))]">{error}</p>}
                    <button type="submit" disabled={busy} className="co-btn-primary w-full h-12" data-testid="reset-submit-btn">
                        {busy ? "Aggiornamento…" : "Aggiorna password"}
                    </button>
                    <Link to="/login" className="text-sm text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--primary))]">
                        Torna al login
                    </Link>
                </form>
            )}
        </div>
    );
}
